import type { ReactNode } from 'react';

interface SuperTokensProviderProps {
  children: ReactNode;
}

export function SuperTokensProvider({ children }: SuperTokensProviderProps) {
  return <>{children}</>;
}
